import { useQueryCache, useMutation } from "react-query";
import { getInspectionQueryKey } from "./useInspection";
import {
  PatchInspectionPrimaryLocationReqBody,
  patchInspectionPrimaryLocation,
} from "../../api/inspections/patchInspectionPrimaryLocation";
import useNetworkHeaders from "../../../../hooks/useNetworkHeaders";

interface Params {
  id: string | number;
  onSuccess?: () => void;
}
export default function useInspectionPrimaryLocationUpdate({ id, onSuccess = () => {} }: Params) {
  const networkHeaders = useNetworkHeaders();
  const queryCache = useQueryCache();

  const inspectionQueryKey = getInspectionQueryKey(id);

  const [updateInspectionPrimaryLocation, updateInspectionPrimaryLocationState] = useMutation(
    patchInspectionPrimaryLocation(networkHeaders, Number(id)),
    {
      onSuccess: () => {
        queryCache.invalidateQueries(inspectionQueryKey);
        onSuccess();
      },
    },
  );

  return {
    isLoading: updateInspectionPrimaryLocationState.isLoading,
    updateInspectionPrimaryLocation: (data: PatchInspectionPrimaryLocationReqBody) =>
      updateInspectionPrimaryLocation(data),
  };
}
